import { render, staticRenderFns } from "./EditorHeading.vue?vue&type=template&id=2f07023d&"
import script from "./EditorHeading.vue?vue&type=script&lang=js&"
export * from "./EditorHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports